<template lang="pug">
    .row.causes__last-row

        .column.column--ext-pl.column--ext-pr.causes

            .aller-selector-small(
                v-observe-visibility='{callback: blockVisibilityChanged, once: true, throttle: 300}'
                )

                .aller-selector-small__icon(
                    v-for='(icon, iconIndex) in data.list'
                    )
                    .aller-selector-small__icon-wrapper(
                        @click='setActvePoint(iconIndex, true)'
                        )
                        .aller-selector-small__icon-sheld.icon-outer(
                            :class='{active: iconIndex === activeIndex}'
                            )
                            svg
                                use(xlink:href='#svg-sheld')
                        .aller-selector-small__icon-inner.icon-inner(
                            :class='{active: iconIndex === activeIndex}'
                            )
                            svg
                                use(:xlink:href='`#all-sel-small-${iconIndex + 1}`')

                .aller-selector-small__text-container-block.selector__textblock(
                    v-for='(slide, slideIndex) in data.list',
                    :class='{active: slideIndex === activeIndex}'
                    )

                    Heading(
                        tag='h3'
                        :text='[slide.heading]'
                        color='red',
                        :centered='true'
                        )
                    
                    p(v-html='slide.text')


</template>
<script>
import Heading from '@/components/utility/Heading.vue';
import Selector from '@/components/mixins/Selector.vue';

export default {
    name: 'SelectorSmall',

    components: {
        Heading
    },

    mixins: [Selector],

    props: {
        data: Object
    },

    data() {
        return {};
    }
};
</script>

<style lang="scss">
@import '@/assets/css/vars.scss';

.aller-selector-small {
    display: grid;
    grid-template-columns: repeat(4, 1fr);
    grid-column-gap: 10vw;
    grid-row-gap: 1vw;

    @media (--viewport-mobile) {
        grid-column-gap: 4vw;
    }

    &__text-container {
        position: relative;

        &-block {
            grid-column: 1 / 5;
            grid-row: 1;
            display: flex;
            flex-direction: column;
            justify-content: center;
            align-items: center;
            opacity: 0;
            pointer-events: none;
            transition: opacity 0.4s ease;

            &.active {
                pointer-events: auto;
                transition: opacity 0.6s ease 0.5s;
                opacity: 1 !important;
            }

            p {
                text-align: center;
            }
        }
    }

    &__icon {
        position: relative;
        display: flex;
        min-height: 8vw;

        @media (--viewport-mobile) {
            min-height: 40vw;
        }

        &:nth-of-type(1) {
            grid-column: 2 / 3;
            grid-row: 2;

            @media (--viewport-mobile) {
                grid-column: 1 / 3;
            }
        }

        &:nth-of-type(2) {
            grid-column: 3 / 4;
            grid-row: 2;

            @media (--viewport-mobile) {
                grid-column: 3 / 5;
            }
        }

        &-wrapper {
            display: flex;
            margin: auto;
        }

        &-sheld {
            position: absolute;
            width: 100%;
            height: 100%;
            top: 0;
            left: 0;
            display: flex;
            flex-direction: row;
            justify-content: center;
            align-items: center;
            cursor: pointer;

            svg {
                transition: fill 0.6s ease;
                fill: var(--color-main-blue-light);

                @media (--viewport-mobile) {
                    width: 40vw;
                    height: 40vw;
                }
            }

            &.active {
                svg {
                    fill: var(--color-main-red);
                }
            }
        }

        &-inner {
            svg {
                margin: auto;
                transition: fill 0.6s ease;
                fill: var(--color-main-blue-mid);

                @media (--viewport-mobile) {
                    width: 20vw;
                    height: 30vw;
                    max-width: 15vw;
                    max-height: 20vw;
                }
            }

            &.active {
                svg {
                    fill: var(--color-main-red);
                }
            }
        }
    }
}
</style>
